<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/flag.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        @if (isEditMode()) {
          {{ 'app.components.routineBuilderDialog.editTitle' | translate }}
        } @else {
          {{ 'app.components.routineBuilderDialog.title' | translate }}
        }
      </h2>
      <p class="parent-dialog__subtitle">
        {{ 'app.components.routineBuilderDialog.subtitle' | translate }}
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.components.routineBuilderDialog.close' | translate"
    (click)="onDiscard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  <form class="parent-dialog__form routine-builder__form" [formGroup]="routineForm">
    <app-input-field
      formControlName="name"
      [label]="'app.components.routineBuilderDialog.nameLabel' | translate"
      [placeholder]="'app.components.routineBuilderDialog.namePlaceholder' | translate"
      [validationErrors]="nameValidation()"
    />

    @if (experiencePoolBalance(); as poolBalance) {
      <div
        class="routine-builder__pool"
        [class.routine-builder__pool--low]="isPoolLow()"
        role="status"
      >
        <img
          class="routine-builder__pool-icon"
          src="/public/svgs/v-star.svg"
          alt=""
          width="16"
          height="16"
          aria-hidden="true"
        />
        <div class="routine-builder__pool-copy">
          <p class="routine-builder__pool-title">
            {{ 'app.components.addDutyDialog.experiencePoolLabel' | translate }}
            <span class="routine-builder__pool-balance">
              {{
                'app.components.addDutyDialog.experiencePoolLeft'
                  | translate: { count: poolBalance }
              }}
            </span>
          </p>
          <p class="routine-builder__pool-hint">
            {{ 'app.components.routineBuilderDialog.experiencePoolHint' | translate }}
          </p>
          <p class="routine-builder__pool-hint">
            {{ 'app.components.addDutyDialog.experienceRewardDefaultHint' | translate }}
          </p>
        </div>
      </div>
    }

    <section class="parent-dialog__section routine-builder__steps">
      <div class="parent-dialog__section-head">
        <span class="parent-dialog__section-label">
          {{ 'app.components.routineBuilderDialog.stepsLabel' | translate }}
        </span>
        <button
          type="button"
          class="parent-dialog__section-action"
          [disabled]="items.length >= 20"
          (click)="addStep()"
        >
          {{ 'app.components.routineBuilderDialog.addStep' | translate }}
        </button>
      </div>

      <p class="routine-builder__hint">
        {{ 'app.components.routineBuilderDialog.stepsHint' | translate }}
      </p>

      <div formArrayName="items" class="routine-builder__list">
        @for (itemGroup of itemGroups(); track $index) {
          <article class="routine-builder__step" [formGroupName]="$index">
            <header class="routine-builder__step-head">
              <span class="routine-builder__step-index">
                {{ 'app.components.routineBuilderDialog.stepNumber' | translate: { number: $index + 1 } }}
              </span>
              @if (items.length > 1) {
                <button
                  type="button"
                  class="routine-builder__remove"
                  [attr.aria-label]="'app.components.routineBuilderDialog.removeStepAria' | translate: { number: $index + 1 }"
                  (click)="removeStep($index)"
                >
                  <img src="/public/svgs/trash-red.svg" alt="" width="14" height="14" aria-hidden="true" />
                </button>
              }
            </header>

            <app-input-field
              formControlName="title"
              [label]="'app.components.routineBuilderDialog.stepTitle' | translate"
              [placeholder]="'app.components.routineBuilderDialog.stepTitlePlaceholder' | translate"
              [validationErrors]="stepTitleValidation()"
            />

            <app-input-field
              formControlName="content"
              [inputType]="'textarea'"
              [label]="'app.components.routineBuilderDialog.stepMessage' | translate"
              [placeholder]="'app.components.routineBuilderDialog.stepMessagePlaceholder' | translate"
              [validationErrors]="stepContentValidation()"
            />

            <div class="routine-builder__rewards">
              <app-input-field
                formControlName="rewardGold"
                [suffixIcon]="'coin.svg'"
                [type]="'number'"
                [label]="'app.components.routineBuilderDialog.moneyReward' | translate"
              />
              <app-input-field
                formControlName="rewardXp"
                [suffixIcon]="'v-star.svg'"
                [type]="'number'"
                [label]="'app.components.routineBuilderDialog.experienceReward' | translate"
              />
            </div>

            <div class="routine-builder__recurrence">
              <span class="routine-builder__recurrence-label">
                {{ 'app.components.routineBuilderDialog.recurrenceLabel' | translate }}
              </span>
              <div class="routine-builder__recurrence-options" role="radiogroup">
                @for (option of recurrenceOptions; track option.id) {
                  <button
                    type="button"
                    class="routine-builder__recurrence-btn"
                    [class.routine-builder__recurrence-btn--selected]="recurrenceForIndex($index) === option.id"
                    [attr.aria-pressed]="recurrenceForIndex($index) === option.id"
                    (click)="selectRecurrence($index, option.id)"
                  >
                    <img [src]="option.icon" alt="" width="16" height="16" aria-hidden="true" />
                    <span>{{ option.labelKey | translate }}</span>
                  </button>
                }
              </div>
            </div>
          </article>
        }
      </div>
    </section>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
  <app-parent-button variant="ghost" (clicked)="onDiscard()">
    {{ 'app.components.routineBuilderDialog.discard' | translate }}
  </app-parent-button>

  <app-parent-button
    variant="primary"
    [loading]="isSubmitting()"
    [disabled]="!canConfirm()"
    (clicked)="onConfirm()"
  >
    @if (!isSubmitting()) {
      <img src="/public/svgs/check-w.svg" alt="" width="14" height="14" aria-hidden="true" />
    }
    @if (isEditMode()) {
      {{ 'app.components.routineBuilderDialog.save' | translate }}
    } @else {
      {{ 'app.components.routineBuilderDialog.create' | translate }}
    }
  </app-parent-button>
</mat-dialog-actions>
